function checkMustEat(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  playerTurn,
  pawnsInTouch
) {
  if (
    (playerTurn === 1 &&
      (boardData[currentSquareIndex][0] === 1 ||
        boardData[currentSquareIndex][0] === 31) &&
      boardData[currentSquareIndex + 9][0] === 2 &&
      boardData[currentSquareIndex + 11][0] === 2) ||
    (playerTurn === 2 &&
      (boardData[currentSquareIndex][0] === 2 ||
        boardData[currentSquareIndex][0] === 32) &&
      boardData[currentSquareIndex - 9][0] === 1 &&
      boardData[currentSquareIndex - 11][0] === 1)
  ) {
    if (playerTurn === 1) {
      pawnsInTouch.push([
        currentSquareIndex + 9,
        currentSquareIndex + 11,
        currentSquareIndex,
      ]);
    } else {
      pawnsInTouch.push([
        currentSquareIndex - 11,
        currentSquareIndex - 9,
        currentSquareIndex,
      ]);
    }
  } else if (
    (playerTurn === 1 &&
      (boardData[currentSquareIndex][0] === 1 ||
        boardData[currentSquareIndex][0] === 31) &&
      boardData[currentSquareIndex + 9][0] === 2) ||
    (playerTurn === 2 &&
      (boardData[currentSquareIndex][0] === 2 ||
        boardData[currentSquareIndex][0] === 32) &&
      boardData[currentSquareIndex - 9][0] === 1)
  ) {
    if (playerTurn === 1) {
      pawnsInTouch.push([currentSquareIndex + 9, currentSquareIndex]);
    } else {
      pawnsInTouch.push([currentSquareIndex - 9, currentSquareIndex]);
    }
  } else if (
    (playerTurn === 1 &&
      (boardData[currentSquareIndex][0] === 1 ||
        boardData[currentSquareIndex][0] === 31) &&
      boardData[currentSquareIndex + 11][0] === 2) ||
    (playerTurn === 2 &&
      (boardData[currentSquareIndex][0] === 2 ||
        boardData[currentSquareIndex][0] === 32) &&
      boardData[currentSquareIndex - 11][0] === 1)
  ) {
    if (playerTurn === 1) {
      pawnsInTouch.push([currentSquareIndex + 11, currentSquareIndex]);
    } else {
      pawnsInTouch.push([currentSquareIndex - 11, currentSquareIndex]);
    }
  }
}

export default checkMustEat;
